"use client";

import { Link, useTranslations } from "@i18n/next";
import { Button } from "@packages/ui";

export const CommunityButton = ({ community, id, challenge }) => {
  const t = useTranslations();

  return (
    <Button asChild isFullWidth size="l">
      <Link
        // Passing the page query param in the loginRedirect url ensures that the user will be redirected to the loginRedirect page even if they are a new user
        href={`/login?redirect=${encodeURIComponent(`/communities/join?id=${community.id}&community=${encodeURIComponent(community.name)}&challengeId=${id}&subRequired=${!challenge.has_access}&page=join-community`)}`}
      >
        {t("community_cta_join")}
      </Link>
    </Button>
  );
};
